import React, { useState, useEffect } from 'react'
import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
  useProSidebar,
  MenuItemStyles,
  menuClasses
} from 'react-pro-sidebar'
import { useNavigate } from 'react-router-dom';
import { BiHelpCircle } from 'react-icons/bi'
import { FaBook, FaUserGraduate } from 'react-icons/fa'
import { AiFillHome } from 'react-icons/ai'
import { TbReportSearch, TbBook, TbCertificate2 } from 'react-icons/tb'
import { GoChecklist } from 'react-icons/go'
import { RiAdminFill } from 'react-icons/ri'
import { TbLayoutSidebarLeftCollapse, TbLayoutSidebarLeftExpand, TbMenu2, TbSquareLetterX } from 'react-icons/tb'
import { IconButton, Grid } from '@mui/material';
import UsuarioService from '../../services/UsuarioService';
import { RolesInvUnidadDTO } from '../../interfaces/Usuarios/RolPersonaUnidadDTO';
import { TbChartHistogram } from "react-icons/tb";
import { HiOutlineCurrencyDollar } from 'react-icons/hi';
/* el color azul del lateral sería azul #243165 y el de los botones #3b6e96 */
const menuItemStyles: MenuItemStyles = {
  icon: {
    borderRadius: '50%',
    backgroundColor: '#3b6e96',
    color: '#ffffff',
    [`&.${menuClasses.active}`]: {
      backgroundColor: '#ffffff',
      color: '#3b6e96'
    }
  },
  root: {
    color: '#ffffff',
    backgroundColor: '#243165',
    overflow: 'initial',
    display: 'block',
  },
  button: {
    '&:hover': {
      backgroundColor: '#3b6e96',
      color: '#ffffff'
    },
    [`&:hover .${menuClasses.icon}`]: {
      backgroundColor: '#ffffff',
      color: '#3b6e96',
      animation: 'swing ease-in-out 0.5s 1 alternate'
    },
    [`&.${menuClasses.active}`]: {
      color: '#ffffff',
      backgroundColor: '#3b6e96',
    }
  }
}

interface Props {
  idInv: number,
  roles: Array<RolesInvUnidadDTO>,
}

const usuarioService = new UsuarioService();

export default function SidebarApp(props: Props) {
  let history = useNavigate()
  const { collapseSidebar } = useProSidebar();
  const [width, setWidth] = useState(0);
  const [collapsed, setCollapsed] = useState(true);
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
    collapseSidebar(menuVisible)
    setCollapsed(menuVisible)
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  }

  const goToNavigation = (site: string) => {
    collapseSidebar(true)
    setCollapsed(true)
    history(site)
  }

  function getSize() {
    setWidth(window.innerWidth)
  }

  function changeRoltoText(opcion: number) {
    let rol: string = "";
    switch (opcion) {
      case 1:
        rol = "ADMINISTRADOR";
        break;
      case 2:
        rol = "ADMINISTRADOR DE UNIDAD";
        break;
      case 3:
        rol = "ANALISTA DE GESTIÓN DE PROYECTOS";
        break;
      case 4:
        rol = "DECANO";
        break;
      case 5:
        rol = "DIRECTOR";
        break;
      case 6:
        rol = "CONSULTOR";
        break;
      case 7:
        rol = "DOCENTE INVESTIGADOR";
        break;
      case 8:
        rol = "RESPONSABLE DE INGRESO DE PRODUCTOS";
        break;
      case 9:
        rol = "ESPECIALISTA DE GESTIÓN DE PROYECTOS";
        break;
      case 10:
        rol = "DELEGADO DE DECANATO DE INVESTIGACIÓN";
        break;
      case 11:
        rol = "SEGUIMIENTO";
        break;
      case 12:
        rol = "EDITOR ORCID";
        break;
      case 13:
        rol = "TÉCNICO INVESTIGADOR";
        break;
      case 14:
        rol = "ASISTENTE DE COORDINACIÓN";
        break;
      default:
        rol = "";
        break;
    }
    return rol;
  }

  useEffect(() => {
    window.addEventListener('resize', getSize);
    if (width > 500) {
      collapseSidebar(false)
      setCollapsed(false)
    } else {
      collapseSidebar(true)
      setCollapsed(true)
    }
    return () => {
      window.removeEventListener('resize', getSize)
    }
  }, [])

  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{ m: 1 }}>
        <div className="circle-button">
          <IconButton aria-label="toggle-menu" onClick={toggleMenu}>
            {menuVisible ?
              <TbSquareLetterX style={{ color: '#ffffff' }} />
              : <TbMenu2 style={{ color: '#ffffff' }} />}
          </IconButton>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Sidebar className={`app sidebar ${menuVisible ? 'visible' : ''}`} backgroundColor="#243165" style={{ height: "90vh" }}>
          <Menu menuItemStyles={menuItemStyles}>
            <MenuItem
              icon={collapsed ? <TbLayoutSidebarLeftExpand /> : <TbLayoutSidebarLeftCollapse />}
              onClick={() => {
                collapseSidebar();
                toggleSidebar();
              }}
              style={{ textAlign: "center" }}
            >
              {" "}
            </MenuItem>
            <MenuItem icon={<AiFillHome />} onClick={() => { goToNavigation('/') }}> Inicio </MenuItem>
            {props.roles.length > 0
              ?
              <SubMenu icon={<TbCertificate2 />} label="Certificados">
                <MenuItem onClick={() => { goToNavigation('/MisCertificados') }}>Mis Certificados</MenuItem>
                <MenuItem onClick={() => { goToNavigation('/SolicitarFirmaDec') }} >Generar Certificado</MenuItem>
              </SubMenu>
              : <></>}
            {/* Productos */}
            {props.roles.length > 0 ?
              <SubMenu icon={<FaBook />} label="Productos">
                <MenuItem onClick={() => { goToNavigation('/Producto/MisProductos') }}> Productos </MenuItem>
                <MenuItem onClick={() => { goToNavigation('/Producto/formularioproducto/0') }}> Formulario </MenuItem>
                {/* { props.roles.includes('ADMINISTRADOR') || props.roles.includes('DECANO') ?
              <MenuItem onClick={() => {goToNavigation('/Producto/busquedaporinvestigador')}}>Por Investigador</MenuItem>
              : <></>
            } */}
                {usuarioService.authorizedByRol(142, props.roles) || usuarioService.authorizedByRol(145, props.roles) || usuarioService.authorizedByRol(144, props.roles) ?
                  <MenuItem onClick={() => { goToNavigation('/Producto/busquedaproductos') }}>Busqueda</MenuItem>
                  : <></>
                }
                {usuarioService.authorizedByRol(142, props.roles) || usuarioService.authorizedByRol(144, props.roles) ?
                  <MenuItem onClick={() => { goToNavigation('/Producto/adjuntarporinvestigador') }}>Adjuntar Proyecto</MenuItem>
                  : <></>
                }
                {/* <MenuItem onClick={() => { goToNavigation('/Producto/productoScopus') }}>Importar Scopus</MenuItem> */}
              </SubMenu> : <></>}
            {/* Proyectos */}
            {true ?
              <SubMenu icon={<TbBook />} label="Proyectos">
                {/* <MenuItem onClick={() => {goToNavigation('proyecto/'+props.idInv+'/0')}}> Nuevo Proyecto </MenuItem> */}
                <MenuItem onClick={() => { goToNavigation('/Proyecto/proyectosAprobados') }}> Aprobados </MenuItem>
              </SubMenu>
              :
              <></>}
            {/* Aprobación */}
            {false ?
              <SubMenu icon={<GoChecklist />} label="Ayudantías">
                <MenuItem onClick={() => { goToNavigation('/Ayudantias/solicitudes') }}> Solicitudes de Ayudantías</MenuItem>
              </SubMenu>
              : <></>}
            {/* usuarioService.authorizedByRol(142,props.roles) || usuarioService.authorizedByRol(143,props.roles) || usuarioService.authorizedByRol(144,props.roles) || usuarioService.authorizedByRol(150,props.roles) || usuarioService.authorizedByRol(145,props.roles) */}
            {false ?
              <SubMenu icon={<FaUserGraduate />} label="Usuario">
                <MenuItem onClick={() => { goToNavigation('/Usuario/Historial') }}>Historial</MenuItem>
              </SubMenu>
              :
              <></>}
            {usuarioService.authorizedByRol(142, props.roles) || usuarioService.authorizedByRol(147, props.roles) || usuarioService.authorizedByRol(150, props.roles)
              ?
              <SubMenu icon={<TbReportSearch />} label="Reportería">
                {usuarioService.authorizedByRol(142, props.roles) ? <MenuItem onClick={() => { goToNavigation('/Reporte/ProyectoPorPersona') }}>Participación</MenuItem> : <></>}
                <MenuItem onClick={() => { goToNavigation('/Reporte/DashBoardProyectos') }}>Reporte General Proyectos</MenuItem>
              </SubMenu>
              :
              <></>
            }
            {usuarioService.authorizedByRol(142, props.roles) || usuarioService.authorizedByRol(147, props.roles)
              ?
              <SubMenu icon={<RiAdminFill />} label="Administración">
                {usuarioService.authorizedByRol(142, props.roles) ?
                  <>
                    <MenuItem><strong>Gestión:</strong></MenuItem>
                    <MenuItem onClick={() => { goToNavigation('/proyecto/busquedaProyectos') }}>Búsqueda de Proyectos</MenuItem>
                    {/* <MenuItem onClick={() => {goToNavigation('/busquedaScopus')}}> Búsqueda Scopus</MenuItem> */}
                  </>
                  : <></>}
                {usuarioService.authorizedByRol(142, props.roles) || usuarioService.authorizedByRol(147, props.roles) ?
                  <>
                    <MenuItem><strong>Configuración:</strong></MenuItem>
                    {usuarioService.authorizedByRol(142, props.roles) || usuarioService.authorizedByRol(147, props.roles) ? <MenuItem onClick={() => { goToNavigation('/Usuarios') }}>Usuarios</MenuItem> : <></>}
                    {usuarioService.authorizedByRol(142, props.roles) ? <MenuItem onClick={() => { goToNavigation('/Sistema') }}>Sistema</MenuItem> : <></>}
                  </>
                  : <></>
                }
              </SubMenu>
              : <></>}
            {usuarioService.authorizedByGroup([142, 143, 144, 145, 150, 156], props.roles) || usuarioService.authorizedByRol(160, props.roles) ?
              <SubMenu icon={<TbChartHistogram />} label="Indicadores">
                {usuarioService.authorizedByRol(160, props.roles) ? <MenuItem onClick={() => { goToNavigation('/Dashboard/Tablero') }}> Desempeño investigación </MenuItem> : <></>}
                {usuarioService.authorizedByGroup([142, 143, 144, 145, 150, 156], props.roles) ? <MenuItem onClick={() => { goToNavigation('/Dashboard/Proyectos') }}> Proyectos </MenuItem> : <></>}
              </SubMenu>
              : <></>}
            {usuarioService.authorizedByRol(142, props.roles) || usuarioService.authorizedByRol(170, props.roles)
              ?
              <SubMenu icon={<HiOutlineCurrencyDollar />} label="Deudas">
                {usuarioService.authorizedByRol(142, props.roles) || usuarioService.authorizedByRol(170, props.roles) ?
                  <>
                    <MenuItem onClick={() => { goToNavigation('/Deudas') }}>Fondos Rotativos</MenuItem>
                  </>
                  : <></>}
              </SubMenu>
              : <></>}
            {/* <MenuItem icon={<BiHelpCircle/>} onClick={() => {goToNavigation('/ayuda')}}>Ayuda</MenuItem> */}
          </Menu>
        </Sidebar>
      </Grid>
    </Grid>
  )
}
